import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import MuiInputTextWithRemainingChars from '@shared/components/MuiInputTextWithRemainingChars';
import AssignmentActionValidator from '../../../../validators/AssignmentActionValidator';
import ConfirmDialog from '@shared/components/confirmDialog/ConfirmDialog';
import FormProviderWrapper from '@shared/components/confirmDialog/dialogWrappers/FormProviderWrapper';
import { DIALOG_MODES } from '@shared/components/confirmDialog/dialogWrappers/constants/DialogModes';
import AssignmentButtons from './AssignmentButtons';

const COMMENT_MAX_LENGTH = 500;
const COMMENT_PLACEHOLDER = 'Please provide any additional commentary';

/**
 * @typedef {object} AssignmentButtonsWithCommentProps
 * @property {(data: { Status: number | string, Comment: string }) => void | Promise<void>} onSubmit
 */

/**
 * @param {AssignmentButtonsWithCommentProps} props
 */
const AssignmentButtonsWithComment = props => {
  const { onSubmit } = props;

  const [openModal, setOpenModal] = useState(false);

  const form = useForm({
    resolver: joiResolver(AssignmentActionValidator.schema),
    defaultValues: {
      Status: '',
      Comment: ''
    }
  });

  const { handleSubmit, setValue, reset, control } = form;

  const handleOnButtonClick = status => {
    setValue('Status', status);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    reset();
  };

  const handleConfirm = async data => {
    await onSubmit(data);
    handleClose();
  };

  const dialogContent = (
    <div className='input-area'>
      <div className='label bold'>Comment</div>
      <Controller
        control={control}
        name='Comment'
        render={({ field }) => (
          <MuiInputTextWithRemainingChars
            {...field}
            className='value'
            disableUnderline
            multiline={true}
            rows={5}
            maxLength={COMMENT_MAX_LENGTH}
            hideRemainingChars={false}
            placeholder={COMMENT_PLACEHOLDER}
          />
        )}
      />
    </div>
  );

  return (
    <>
      <AssignmentButtons onAction={handleOnButtonClick} />

      <FormProviderWrapper form={form}>
        <ConfirmDialog
          dialogClassName='date-request-dialog'
          open={openModal}
          message={null}
          handleClose={handleClose}
          dialogContent={dialogContent}
          handleOnConfirm={handleSubmit(handleConfirm)}
          confirmBtnText='Submit'
          cancelBtnText='Cancel'
          disableConfirmBtn={false}
          formId={null}
          dialogMode={DIALOG_MODES.INTERNAL_FORM}
        />
      </FormProviderWrapper>
    </>
  );
};

export default AssignmentButtonsWithComment;
